import { themedStyled } from 'common/styles/styletron.theme';

export const HalfSection = themedStyled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: '50%',
});

export const ActionButton = themedStyled('div', ({ $theme }) => ({
  cursor: 'pointer',
  color: $theme.colors.primaryDefault,
  paddingLeft: '4px',
  paddingRight: '4px',
  ':hover': {
    textDecoration: 'underline',
  },
  ':focus': {
    outlineColor: $theme.colors.primaryDefault,
  },
}));
